<div class="shadow-box flex flex-col items-center max-w-screen-sm w-full text-center  dark:bg-background-dark">
    @if(course && course.isDemoCourse){
    <app-demo-banner></app-demo-banner>
    }
    <img src="./assets/img/exam-start-penguin.webp" alt="Los gehts" class="w-40 h-40 my-4 rounded-full object-cover" />
    @if(test){
    <h3>Los gehts mit der Prüfungssimulation für {{ test.expand.conditions.name }}!</h3>
    <p class="px-4 sm:px-20 text-center	mt-4">
        In {{ test.expand.conditions.time_limit }} Minuten gilt es {{ test.expand.conditions.question_amount }} Fragen
        zu bewältigen.
        Vor der Abgabe und während der Prüfung kannst du jederzeit zwischen den beantworteten Fragen hin und her
        wechseln.
        Ist der Timer abgelaufen, werden die Fragen automatisch eingereicht.
    </p>
    <p class="px-4 sm:px-20 text-center">
        Viel Erfolg!
    </p>
    <button [routerLink]="['/test', test.id]" class="blue-button mt-6 mb-10 w-3/4">Starten</button>
    } @else {
    <ng-icon size="3rem" class="animate-spin" name="faSolidSpinner"></ng-icon>
    }
    <!-- <div class="text-xs text-grey">This product is not affiliated with nor endorsed by scrum.org. All questions are self-created and based solely on the publicly available Scrum Guide.</div> -->
    <div class="text-xs dark:text-grey text-gray-400">Dieses Produkt steht in keiner Verbindung zu scrum.org und wird von dieser weder
        unterstützt noch gefördert. Alle Fragen sind selbst erstellt und basieren ausschließlich auf dem öffentlich
        verfügbaren Scrum Guide.</div>
</div>